import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    eventdate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    theme: {
      validations: []
    },
    category: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    sitename: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventdate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type:',
            options: [
              { label: 'Breakfast'  , value: 'Breakfast'},
              { label: 'Box Lunch'  , value: 'Box Lunch'},
              { label: 'Lunch'  , value: 'Lunch'},
              { label: 'Dinner'  , value: 'Dinner'},
              { label: 'Reception'  , value: 'Reception'},
              { label: 'Drop-off/Delivery'  , value: 'Drop-off/Delivery'},
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Menu Selection:',
            options: [
              { label: 'Continental Breakfast '  , value: 'Continental Breakfast '},
              { label: 'Energy Breakfast '  , value: 'Energy Breakfast '},
              { label: 'Traditional Breakfast  '  , value: 'Traditional Breakfast  '},
              { label: 'Build Your Own Breakfast '  , value: 'Build Your Own Breakfast '},
              { label: 'Toast Bar '  , value: 'Toast Bar '},
              { label: 'Table d’hote'  , value: 'Table d’hote'},
              { label: 'Hand Crafted Egg Sandwiches'  , value: 'Hand Crafted Egg Sandwiches'},
              { label: 'Classic Deli Buffet '  , value: 'Classic Deli Buffet '},
              { label: 'Expressed Boxed Lunch'  , value: 'Expressed Boxed Lunch'},
              { label: 'Artisan Box Lunch'  , value: 'Artisan Box Lunch'},
              { label: 'Craft Salads '  , value: 'Craft Salads '},
              { label: 'Little Italy '  , value: 'Little Italy '},
              { label: 'Southern Delight '  , value: 'Southern Delight '},
              { label: 'The Grill '  , value: 'The Grill '},
              { label: 'Taste of Mediterranean '  , value: 'Taste of Mediterranean '},
              { label: 'Taco House '  , value: 'Taco House '},
              { label: 'Asia Fusion '  , value: 'Asia Fusion '},
              { label: 'Hors d’Oeuvres'  , value: 'Hors d’Oeuvres'},
              { label: 'Pasta Station '  , value: 'Pasta Station '},
              { label: 'Sweet Things '  , value: 'Sweet Things '},
              { label: 'Balanced Breaks'  , value: 'Balanced Breaks'},
              { label: 'Sweets & Treats'  , value: 'Sweets & Treats'},
              { label: 'Beverages'  , value: 'Beverages'},
              { label: 'Carved for you '  , value: 'Carved for you '},
              { label: 'Cordially Invited'  , value: 'Cordially Invited'},
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Guest Count:',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Location:',
            options: [
              { label: 'Harrison B. Wilson Hall (Administration Building)'  , value: 'Harrison B. Wilson Hall (Administration Building)'},
              { label: 'President\'s House' , value: 'President\'s House'},
              { label: 'L. Douglas Wilder Performing Arts Center'  , value: 'L. Douglas Wilder Performing Arts Center'},
              { label: 'E. L. Hamm Fine Arts Building'  , value: 'E. L. Hamm Fine Arts Building'},
              { label: 'Facilities Management/ Central Warehouse'  , value: 'Facilities Management/ Central Warehouse'},
              { label: 'Tennis Complex'  , value: 'Tennis Complex'},
              { label: 'Samuel F. Scott Hall'  , value: 'Samuel F. Scott Hall'},
              { label: 'West Campus Dining Hall'  , value: 'West Campus Dining Hall'},
              { label: 'Rosa A. Alexander Hall'  , value: 'Rosa A. Alexander Hall'},
              { label: 'Babbette B. Smith North Hall'  , value: 'Babbette B. Smith North Hall'},
              { label: 'Babbette B. Smith South Hall'  , value: 'Babbette B. Smith South Hall'},
              { label: 'Phillis Wheatley Hall '  , value: 'Phillis Wheatley Hall '},
              { label: 'Brambleton Community Outreach Center '  , value: 'Brambleton Community Outreach Center '},
              { label: 'William P. Robinson, Sr. Technology Center '  , value: 'William P. Robinson, Sr. Technology Center '},
              { label: 'James A. Bowser Building '  , value: 'James A. Bowser Building '},
              { label: 'University Police Station '  , value: 'University Police Station '},
              { label: 'Lyman Beecher Brooks Library '  , value: 'Lyman Beecher Brooks Library '},
              { label: 'Softball Field'  , value: 'Softball Field'},
              { label: 'Marty Miller Baseball Field '  , value: 'Marty Miller Baseball Field '},
              { label: 'White House Memorial Garden '  , value: 'White House Memorial Garden '},
              { label: 'G.W.C. Brown Memorial Hall '  , value: 'G.W.C. Brown Memorial Hall '},
              { label: 'Mary Scott/ Dozier Dining Hall '  , value: 'Mary Scott/ Dozier Dining Hall '},
              { label: 'Student Services Center '  , value: 'Student Services Center '},
              { label: 'Student Center '  , value: 'Student Center '},
              { label: 'James D. Gill Health & Physical Education Building '  , value: 'James D. Gill Health & Physical Education Building '},
              { label: 'Sports Medicine Center'  , value: 'Sports Medicine Center'},
              { label: 'William "Dick" Price Football Stadium'  , value: 'William "Dick" Price Football Stadium'},
              { label: 'Hugo Madison Hall '  , value: 'Hugo Madison Hall '},
              { label: 'Bozeman Building '  , value: 'Bozeman Building '},
              { label: 'Roy A. Woods Science Building '  , value: 'Roy A. Woods Science Building '},
              { label: 'Ticket Office '  , value: 'Ticket Office '},
              { label: 'Joseph G. Echols Memorial Hall '  , value: 'Joseph G. Echols Memorial Hall '},
              { label: 'Picnic Area '  , value: 'Picnic Area '},
              { label: 'Nursing and General Education Building '  , value: 'Nursing and General Education Building '},
              { label: 'Spartan Suites '  , value: 'Spartan Suites '},
              { label: 'Charles H. Smith Hall'  , value: 'Charles H. Smith Hall'},
              { label: 'Honor\'s College - Midrise Residence Hall '  , value: 'Honor\'s College - Midrise Residence Hall '},
              { label: 'Lee W. Smith Hall '  , value: 'Lee W. Smith Hall '},
              { label: 'Spartan Station '  , value: 'Spartan Station '},
              { label: 'Marie V. McDemmond Center for Applied Research '  , value: 'Marie V. McDemmond Center for Applied Research '},
              { label: 'Football Practice Field '  , value: 'Football Practice Field '},
              { label: 'Track & Field Annex '  , value: 'Track & Field Annex '},
              { label: 'Green House'  , value: 'Green House'},
            ],
            mapping: 'sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Any Additional Details About Your Event?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Thompson Hospitality - Norfolk State University Contact Form',
    formId: '2141',
    clientKey: '08952193-C10D-477C-8F51-40FA514EDE08',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    submissionText: 'Thank you! Your request has been received. Our catering coordinator will reach out to you within 24 business hours.',
    redirectUrl: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
